import Head from 'next/head';
import { ReactElement } from 'react';
import { Faq, Banner, Section, SectionIntro } from '../components/Website';
import AppHeaderLayout from '@root/components/App/Layouts/AppHeaderLayout';
import { basePhotoUrl } from '@global/constants';
export default function About(): ReactElement {
  const AvatarCards1 = [
    {
      src: '/images/avatar-wouter.jpg',
      heading: 'Wouter van den Brink',
      subtitle: 'CEO, Co-Founder',
    }, {
      src: '/images/avatar-esmee.jpg',
      heading: 'Esmée Clewits',
      subtitle: 'Head of Creative, Co-Founder',
    }, {
      src: '/images/avatar-raymond.jpg',
      heading: 'Raymond Joore',
      subtitle: 'CCO, Co-Founder',
    }, {
      src: '/images/avatar-blank.svg',
      heading: 'Open role',
      subtitle: 'Chief Product Technology Officer',
    },
  ];
  const AvatarCards2 = [
    {
      src: '/images/avatar-jasper.jpg',
      heading: 'Jasper den Ouden',
      subtitle: 'UX Designer at Strakzat',
    }, {
      src: '/images/avatar-rob.jpg',
      heading: 'Rob Scholten',
      subtitle: 'Digital Designer at Strakzat',
    }, {
      src: '/images/avatar-murtada.jpg',
      heading: 'Murtada al Mousawy',
      subtitle: 'Developer at Strakzat',
    }, {
      src: '/images/avatar-gideon.jpg',
      heading: 'Gideon Heilbron',
      subtitle: 'Developer at Strakzat',
    },
  ];
  const AvatarCards3 = [
    {
      src: '/images/avatar-buphinder.jpg',
      heading: 'Buphinder Singh',
      subtitle: 'Founder & Managing Partner at Marveltest',
    }, {
      src: '/images/avatar-rianne.jpg',
      heading: 'Rianne Okkema',
      subtitle: 'Digital Growth Consultant at Marveltest',
    }, {
      src: '/images/avatar-diana.jpg',
      heading: 'Diana Pantaia',
      subtitle: 'Digital Growth Consultant at Marveltest',
    },
  ];
  const AvatarCards4 = [
    {
      src: '/images/avatar-marischa.jpg',
      heading: 'Marischa van Zantvoort',
      subtitle: 'CEO and Managing Partner, Loyd Consulting Group',
    }, {
    //   src: "/images/avatar-valerie.jpg",
    //   heading: "Valerie Smit",
    //   subtitle: "Founding Partner, Six & Seven Invest"
    // }, {
    //   src: "/images/avatar-age.jpg",
    //   heading: "Age Hollander",
    //   subtitle: "Founding Partner, H2 Equity Partners"
    // }, {
      src: '/images/avatar-jan.jpg',
      heading: 'Jan Willem Cramer',
      subtitle: 'Senior Advisor, Van Lanschot Kempen',
    }, {
      src: '/images/avatar-ronald.jpg',
      heading: 'Ronald van Zetten',
      subtitle: 'Former CEO HEMA',
    },
  ];

  return (
    <>
      <Head>
        <title>YourDesq | About</title>
        <meta property="og:image" content={ basePhotoUrl } />
      </Head>

      <main>
        <Banner
          heading={ <span>Work where you work best</span> }
          description={ <span>We believe the future of work is hybrid, output driven and sustainable!</span> }
          variant="tertiary"
          media="/images/banner-about@1x.jpg"
          media2x="/images/banner-about@2x.jpg"
        />

        <Section variant="quaternary">
          <div className="container">
            <SectionIntro
              title="About us"
              variant="secondary"
              columns={ [ 'The world has experienced working from home is not the right solution, working hybrid is! And that’s where YourDesq comes in. We are building a platform that creates the ability to increase your social connectivity, keep your flexibility, improve your sustainable footprint and most importantly enhance your productivity.', 'On the other hand we offer businesses the opportunity to think differently about their office space. To manage the use of their office space dynamically and cost efficient, while enabling employees to work hybrid. We will welcome this new community of users and hosts to our platform from 2021.' ] }
            />
          </div>
        </Section>

        <Section>
          <div className="container">
            <SectionIntro
              title="The faces behind YourDesq"
              subtitle="Together we build a platform to facilitate the new way of working. All from a different point of view, with a different expertise."
            />

            <SectionIntro
              title="Board of Advisors"
              variant="tertiary"
              small
              alignLeft
            />

            <ul className="section-cards">
              {AvatarCards4.map((card: any, cardIndex: number) =>
                <li className="col-m3" key={ cardIndex }>
                  <div className="section-card">
                    <div className="section-card__header">
                      <img className="section-card__avatar" src={ card.src } />
                    </div>
                    <h6 className="section-card__heading">{card.heading}</h6>
                    <div className="section-card__subtitle">{card.subtitle}</div>
                  </div>
                </li>
              )}
            </ul>

            <SectionIntro
              title="Leadership"
              variant="tertiary"
              small
              alignLeft
            />

            <ul className="section-cards">
              {AvatarCards1.map((card: any, cardIndex: number) =>
                <li className="col-m3" key={ cardIndex }>
                  <div className="section-card">
                    <div className="section-card__header">
                      <img className="section-card__avatar" src={ card.src } />
                    </div>
                    <h6 className="section-card__heading">{card.heading}</h6>
                    <div className="section-card__subtitle">{card.subtitle}</div>
                  </div>
                </li>
              )}
            </ul>

            <SectionIntro
              title="Strakzat"
              subtitle="Product Development"
              variant="tertiary"
              small
              alignLeft
            />

            <ul className="section-cards">
              {AvatarCards2.map((card: any, cardIndex: number) =>
                <li className="col-m3" key={ cardIndex }>
                  <div className="section-card section-card--secondary">
                    <div className="section-card__header">
                      <img className="section-card__avatar" src={ card.src } />
                    </div>
                    <h6 className="section-card__heading">{card.heading}</h6>
                    <div className="section-card__subtitle">{card.subtitle}</div>
                  </div>
                </li>
              )}
            </ul>

            <SectionIntro
              title="Marveltest"
              subtitle="Marketing, Growth Hacking"
              variant="tertiary"
              small
              alignLeft
            />

            <ul className="section-cards">
              {AvatarCards3.map((card: any, cardIndex: number) =>
                <li className="col-m3" key={ cardIndex }>
                  <div className="section-card section-card--secondary">
                    <div className="section-card__header">
                      <img className="section-card__avatar" src={ card.src } />
                    </div>
                    <h6 className="section-card__heading">{card.heading}</h6>
                    <div className="section-card__subtitle">{card.subtitle}</div>
                  </div>
                </li>
              )}
            </ul>

          </div>
        </Section>

      </main>

      <Section>
        <div className="container">
          <SectionIntro
            title="Frequently Asked Questions"
            subtitle="We’re always happy to help you out. Find answers to the most asked questions for hosts below!"
          />
        </div>

        <Faq
          items={ [
            {
              question: 'How do I create an account?',
              answer: `
                <ol>
                <li>If you don't have an YourDesq account yet, go to YourDesq.com and click Sign Up.</li>
                <li>You can sign up for an account using your email address or Google account. Signing up and creating an YourDesq account is free.</li>
                <li>After you sign up, be sure to complete your profile before you make a reservation or create a listing.</li>
                </ol>
                `,
            }, {
              question: 'How do I create a listing?',
              answer: `
                  <p>To create a listing as a Host you go to your account and start a new listing. Every Workplace (location) needs its own listing. The following information is needed:</p>
                  <ol>
                  <li>Name of the Workplace;</li>
                  <li>The location of the Workplace;</li>
                  <li>The type of Workplace;<br />
                  E.g. hotel, coworking space, office</li>
                  <li>The available Workspaces within the Workplace;<br />
                  E.g. a flex desk, a workstation, a private office or a meeting room</li>
                  <li>What amenities the Workplace has;</li>
                  <li>What amenities specific Workspaces have;</li>
                  <li>The price per day per type of Workspace;</li>
                  <li>The availability of the Workspaces per day.</li>
                  </ol>
                  `,
            }, {
              question: 'What is a Workplace?',
              answer: `
                <p>Every Host creates 1 listing per 1 Workplace. A WorkPlace is a building or floor level(s) within a building e.g. the office. A company can own or rent one or more Workplaces, however we ask you to use 1 Workplace per listing, as follows:</p>
                <ol>
                <li>1 Workplace has 1 country</li>
                <li>1 Workplace has 1 city</li>
                <li>1 Workplace has 1 address</li>
                <li>1 WorkPlace has 1 district</li>
                </ol>
                `,
            }, {
              question: 'What is a Workspace?',
              answer: `
                <p>A User searches for a Workplace which contains one or multiple Workspaces. Workspaces can be categorized as follows:</p>
                <ol>
                <li>Flex desk (flex workstation within an open space)</li>
                <li>Workstation (dedicated workstation within a shared office or open space)</li>
                <li>Private office (probably for 1 - 2 persons)</li>
                <li>Meeting room (probably for 4+ persons)</li>
                </ol>
                `,
            }, {
              question: 'What is a Workplace amenity?',
              answer: `
                <p>A Workplace amenity is a shared amenity that every user may use that visits your Workplace. These amenities are not dedicated to specific workstations, private offices or meeting rooms.</p>
                `,
            }, {
              question: 'What is Workspace amenity?',
              answer: `
                <p>Workspace amenities are amenities dedicated to the User that booked a specific Workspace. E.g. A workstation has a dedicated monitor. A meeting room has a dedicated projection screen.</p>
                `,
            }, {
              question: 'How do I decide what to charge for my Listing?',
              answer: `
                <p>The price you set is always up to you. We recommend that you check out similar YourDesq Listings near you. When you create a YourDesq Listing, we help you determine the right price. Pricing is based on the following principles:</p>
                <ol>
                <li>The local price paid for an office per meter per year;</li>
                <li>What kind of space you offer. For example facilitating a meeting room for 10 people or a smaller workstation.</li>
                </ol>
                <p>If you don't feel comfortable with the suggested price, you can just change it to a price you think is suitable for your offered space.</p>
                `,
            }, {
              question: 'How do I manage my Listings?',
              answer: `
                <p>To manage your listing go Account and click My Listings</p>
                `,
            }, {
              question: 'How do I reset my password?',
              answer: `
                <p>To reset your password go to Account and click Account Settings and change your password. </p>
                `,
            }, {
              question: 'How do I edit my account settings?',
              answer: `
                <p>To change your profile settings or any other account settings go to Account and click Account Settings.</p>
                `,
            }, {
              question: 'What are the requirements to book a Workspace on YourDesq as a User?',
              answer: `
                <p>As a User, we ask you to fill in your account details as completely as possible. The following information is requested:</p>
                `,
            }, {
              question: 'How do I book a Workspace on YourDesq?',
              answer: `
                <p>After completing your profile as a User you’re able to book a Workspace on YourDesq. Within the search page you’re able to select your location, preferred day, type of Workspace, the amount of people and needed amenities. Select the Workplace that suits your preferences and book a Workspace right away! Keep in mind that your Host needs to accept your reservation before your booking is confirmed. You can keep track of this process within the Booking section & Inbox.</p>
                `,
            }, {
              question: 'How do I know the Host has received my booking request?',
              answer: `
                <p>We keep you updated with our email confirmations. We will send you an email saying your payment has been processed and your reservation has been confirmed. Note: a confirmed reservation does not guarantee a confirmed booking.</p>
                `,
            }, {
              question: 'How do I know my booking is confirmed by the Host?',
              answer: `
                <p>Once your reservation has been confirmed, the Host will receive your booking request in his inbox. The Host will then review your request and approve or deny your booking request. When the Host confirms your booking, you will receive a Booking Confirmation in your YourDesq Inbox and in your email. The Booking Confirmation will contain all necessary booking details: host, location, time and payment.</p>
                `,
            }, {
              question: 'How do I pay the Host?',
              answer: `
                <p>When you go through the booking process you will end up in the payment section to confirm your reservation. Here you can pay with Ideal, Mastercard & Visa. The amount paid will be held until the Host accepts your booking. If this does not happen, we will automatically refund you.</p>
                `,
            }, {
              question: 'How do I contact a Host as a User?',
              answer: `
                <p>To contact your Host use the chat function within your Account. Go to Account -> Inbox and find your chat per reservation.</p>
                `,
            }, {
              question: 'How do I contact a User as a Host?',
              answer: `
                <p>To contact your User use the chat function within your Account. Go to Account -> Inbox and find your chat per reservation.</p>
                `,
            }, {
              question: 'How do I contact YourDesq?',
              answer: `
                <p>Reach out to use by email: <a href="mailto:hello@yourdesq.com">hello@yourdesq.com</a>, we’ll try to answer you within 24 hours.</p>
                `,
            }, {
              question: 'How do I cancel a reservation as a User?',
              answer: `
                <p>As a User you can cancel a booking up to 24 hours before the start of the booking. Go to the Booking section and press Cancel Reservation. We’ll automatically inform the Host and refund you.Unfortunately we cannot accept cancellations later than 24 hours in advance.</p>
                `,
            }, {
              question: 'How do I cancel a reservation as a Host?',
              answer: `
                <p>As a User you can cancel a booking up to 48 hours before the start of the booking. Go to the Booking section and press Cancel Reservation. We’ll automatically inform and refund the User.Unfortunately we cannot accept cancellations later than 48 hours in advance.</p>
                `,
            }, {
              question: 'How do I get paid as a Host?',
              answer: `
                <p>Once a Host accepts a reservation the booking is completed. The User pays in advance and this amount will be paid to the Host within 24 hours after check-in.</p>
                `,
            }, {
              question: 'How does a User check in?',
              answer: `
                <p>A host will communicate how a user checks in on location.</p>
                `,
            }, {
              question: 'What happens if Users don’t show up or don’t check in?',
              answer: `
                <p>When Users don’t show up or don’t check in, but the booking has not been canceled in time, you will receive the booking payment within 24 hours after the scheduled check-in.</p>
                `,
            }, {
              question: 'Is YourDesq responsible for accidents in the Workplace?',
              answer: `
                <p>No, we take no liability in any accident that might take place in the Workplace or Workspace.</p>
                `,
            }, {
              question: 'Am I insured as a Host through YourDesq? ',
              answer: `
                <p>To ensure quality for both our hosts and users, we have put in place a number of safety rules to ensure everyone gets the quality they deserve.</p>
                <ol>
                  <li>A user must create an account before he or she can book a Workspace.</li>
                  <li>When an account is created, the user must create a profile that describes more about the User, such as professional background. The profile is necessary to create a transparent community built on trust and quality.</li>
                  <li>When a User makes a reservation, it is up to you to decide whether to accept or decline their booking request.</li>
                  <li>We advise you to set clear office rules and describe preferred professionals you would like to welcome.</li>
                </ol>
                `,
            }, {
              question: 'What is YourYourDesq doing about Covid-19?',
              answer: `
                <p>Of course we keep observing the Covid-19 measures. Locations will be available as long as the measures allow. In addition, these workplaces will act as safely as possible. Users and Hosts remain responsible at all times for the use of YourDesq.</p>
                `,
            },
          ] }
        />
      </Section>
    </>
  );
}

About.Layout = AppHeaderLayout;
